export default "/local/templates/atc_1pdr/dist/images/icon-map-marker.svg?cbeb64aa452fe74a5d71f127e74500f2";